import { faThumbsDown, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { callWrite, UPDATE_LLM_VISIT_FEEDBACK } from '../../amplify/api-gateway/write';

function FeedbackModal({
    isPositiveFeedback,
    messageId,
    activeFeedback,
    setActiveFeedback,
}: any) {
    const [show, setShow] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [feedback, setFeedback] = useState("");
    const [feedbackNotHelpful, setFeedbackNotHelpful] = useState(false);
    const [feedbackTooGeneral, setFeedbackTooGeneral] = useState(false);
    const [feedbackIncorrect, setFeedbackIncorrect] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const sendFeedback = () => {
        setSubmitting(true);
        let finalFeedback = "";
        if (feedbackNotHelpful) {
            finalFeedback += "[NOT HELPFUL]";
        } else if (feedbackTooGeneral) {
            finalFeedback += "[TOO GENERAL]";
        } else if (feedbackIncorrect) {
            finalFeedback += "[INCORRECT]";
        }

        if (finalFeedback !== "") {
            finalFeedback += " ";
        }
        finalFeedback += feedback;

        callWrite({
            operation: UPDATE_LLM_VISIT_FEEDBACK,
            creation_time: new Date().getTime(),
            csn: '',
            mrn: '',
            feedback_target: messageId,
            feedback_type: `assistant_${isPositiveFeedback ? "POSITIVE" : "NEGATIVE"}`,
            note: finalFeedback,
        }).then((response) => {
            console.log("Feedback submitted...");
            setActiveFeedback({
                ...activeFeedback,
                [messageId]: isPositiveFeedback ? "POSITIVE" : "NEGATIVE",
            })
            setSubmitting(false);
            handleClose();
        }).catch((err: any) => {
            console.error(err);
            setSubmitting(false);
            handleClose();
        })
    };

    return (
        <>
            <Button variant="link" className={(activeFeedback[messageId] === "POSITIVE" && isPositiveFeedback) || (activeFeedback[messageId] === "NEGATIVE" && !isPositiveFeedback) ? "assistant-feedback-active-btn me-1" : "assistant-feedback-btn me-1"} onClick={handleShow}>
                {/* @ts-ignore */}
                <FontAwesomeIcon icon={isPositiveFeedback ? faThumbsUp : faThumbsDown} />
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    {/* @ts-ignore */}
                    <Modal.Title><span style={{fontSize: '1.2rem'}}><FontAwesomeIcon icon={isPositiveFeedback ? faThumbsUp : faThumbsDown} />{' '}|{' '}Submit Feedback</span></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Provide any additional feedback</Form.Label>
                            <Form.Control as="textarea" rows={3} onChange={(event) => {setFeedback(event.target.value)}} />
                        </Form.Group>
                        {
                            !isPositiveFeedback && (
                                <>
                                    <Form.Check
                                        type='checkbox'
                                        id={`feedback-not-helpful`}
                                        label={`Not Helpful`}
                                        checked={feedbackNotHelpful}
                                        onChange={(e) => setFeedbackNotHelpful(!feedbackNotHelpful)}
                                    />
                                    <Form.Check
                                        type='checkbox'
                                        id={`feedback-too-general`}
                                        label={`Too General`}
                                        checked={feedbackTooGeneral}
                                        onChange={(e) => setFeedbackTooGeneral(!feedbackTooGeneral)}
                                    />
                                    <Form.Check
                                        type='checkbox'
                                        id={`feedback-incorrect`}
                                        label={`Incorrect`}
                                        checked={feedbackIncorrect}
                                        onChange={(e) => setFeedbackIncorrect(!feedbackIncorrect)}
                                    />
                                </>
                            )
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="secondary" onClick={() => sendFeedback()} disabled={submitting}>
                        {
                            submitting ? (
                                <FontAwesomeIcon icon={faSpinner} spin />
                            ) : (
                                <>Submit Feedback</>
                            )
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default FeedbackModal;
